import { createContext, useContext, useState } from "react";

const PagesContext = createContext({
    isOpen: false,
    currentPage: "main"
})

export default PagesContext